import { render, staticRenderFns } from "./InvitationsTable.vue?vue&type=template&id=6e0b17b0&scoped=true&"
import script from "./InvitationsTable.vue?vue&type=script&lang=js&"
export * from "./InvitationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b17b0",
  null
  
)

export default component.exports